/* Sort-by select auto-submit + filter panel behaviour. Loaded by sections/main-collection.liquid
   and sections/main-search.liquid. */
(function () {
  'use strict';

  var doc = document;
  var $ = function (sel, root) { return (root || doc).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };

  /* ---------- Collection sort ---------- */
  function initSort(root) {
    var form = $('[data-sort-form]', root);
    var sel = $('[data-sort-select]', root);
    if (form && sel) sel.addEventListener('change', function () { form.submit(); });
  }

  /* ---------- Collection filters ---------- */
  function initFilters(root) {
    var form = $('[data-filters]', root);
    if (!form) return;
    var toggle = $('[data-filters-toggle]', form);
    if (toggle) {
      // CSS folds the panel on <=989px; this only flips the class + aria state
      toggle.addEventListener('click', function () {
        var open = !form.classList.contains('is-open');
        form.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
      var body = $('.filters__body', form);
      if (body && body.offsetParent !== null) toggle.setAttribute('aria-expanded', 'true');
    }
  }

  /* ---------- Quick facets (searchable dropdowns above the product list) ---------- */
  // Pure, node-tested (tests/storefront/test_theme_collection_filters.py): case-insensitive substring, blank matches all.
  function match(label, query) {
    query = (query || '').trim().toLowerCase();
    return !query || String(label || '').toLowerCase().indexOf(query) !== -1;
  }

  function initQuickFacets(root) {
    var bar = $('[data-quick-facets]', root);
    if (!bar) return;
    var facets = $$('[data-qf]', bar);
    function closeAll(except) {
      facets.forEach(function (f) { if (f !== except) f.removeAttribute('open'); });
    }
    facets.forEach(function (facet) {
      var search = $('[data-quick-search]', facet);
      var items = $$('[data-quick-list] li', facet);
      var empty = $('[data-quick-empty]', facet);
      facet.addEventListener('toggle', function () {
        if (!facet.open) return;
        closeAll(facet);
        if (search) { search.value = ''; filter(''); search.focus(); }
      });
      function filter(q) {
        var shown = 0;
        items.forEach(function (li) {
          var hit = match(li.textContent, q);
          li.hidden = !hit;
          if (hit) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      }
      if (search) {
        search.addEventListener('input', function () { filter(search.value); });
        // Enter on a single remaining value follows it
        search.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          var visible = items.filter(function (li) { return !li.hidden; });
          if (visible.length === 1) { e.preventDefault(); visible[0].querySelector('a').click(); }
        });
      }
    });
    doc.addEventListener('click', function (e) { if (!bar.contains(e.target)) closeAll(null); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  }

  /* ---------- List / grid view toggle ---------- */
  // Both layouts are in the DOM; [data-view] on the results container picks one (CSS). The inline
  // script in main-collection.liquid already applied the stored choice before paint; this wires
  // the buttons and keeps aria-pressed in step.
  var VIEW_KEY = 'pf_collection_view';

  function readView(value) {
    return value === 'grid' || value === 'list' ? value : null;
  }

  function initViewToggle(root) {
    var toggle = $('[data-view-toggle]', root);
    var results = $('[data-view-results]', root);
    if (!toggle || !results) return;
    var buttons = $$('[data-view]', toggle);
    function apply(view, persist) {
      results.setAttribute('data-view', view);
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-view') === view)); });
      if (persist) { try { localStorage.setItem(VIEW_KEY, view); } catch (e) { /* private mode */ } }
    }
    var stored = null;
    try { stored = readView(localStorage.getItem(VIEW_KEY)); } catch (e) { /* private mode */ }
    apply(stored || readView(results.getAttribute('data-view')) || 'list', false);
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-view'), true); });
    });
  }

  window.theme.quickFacets = { match: match };
  window.theme.collectionView = { readView: readView, key: VIEW_KEY };

  window.theme.register(function (root) {
    initSort(root);
    initFilters(root);
    initQuickFacets(root);
    initViewToggle(root);
  });
})();
